import AutoComplete from "react-google-autocomplete";
import { Button } from "../components/Actions";
import { CongressEmailContent } from "../components/CongressEmailContent/CongressEmailContent";
import SEO from "../components/Seo/Seo";
import { TextInput } from "../components/Inputs/TextInput";
import { useState } from "react";

export async function getStaticProps() {
  return {
    props: {
      NEXT_GEOCODIO_API_KEY: process.env.NEXT_GEOCODIO_API_KEY,
      NEXT_GOOGLE_API_KEY: process.env.NEXT_GOOGLE_API_KEY
    } // will be passed to the page component as props
  };
}

const ContactCongress = ({
  NEXT_GEOCODIO_API_KEY,
  NEXT_GOOGLE_API_KEY
}: any) => {
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState("");

  const [legislator, setLegislator] = useState(null);

  const [loadingRepresentative, setLoadingRepresentative] = useState(false);

  const getNearestRepresentative = async () => {
    setLoadingRepresentative(true);

    const response = await fetch(
      `https://api.geocod.io/v1.7/geocode?q=${address}&fields=cd&api_key=${NEXT_GEOCODIO_API_KEY}`
    );

    const jsonResponse = await response.json();

    const legislator =
      jsonResponse.results[0]?.fields.congressional_districts[0]?.current_legislators.find(
        (legislator: { type: string }) => legislator.type === "representative"
      );

    setLegislator(legislator);
    setLoadingRepresentative(false);
  };

  return (
    <>
      <SEO title="Contact Congress | Coinage Media" />
      <section className="flex max-w-4xl p-8 py-16 flex-col items-center mx-auto gap-8">
        <h1 className="subhead1 text-center">
          Find and contact your representative in Congress
        </h1>
        <p className="body1 text-coinage-body max-w-prose text-center">
          Enter your details to find your representative in Congress, and we&#39;ll
          generate an email for you.
        </p>
        <div className="grid sm:grid-cols-3 md:grid-cols-6 gap-2 w-full">
          <TextInput
            className={`col-span-3 tab:w-full w-full`}
            placeholder="Full Name"
            onChange={e => setFullName(e.target.value)}
          />
          <AutoComplete
            apiKey={NEXT_GOOGLE_API_KEY}
            className="rounded-l-md px-4 py-2 border-slate-50 tab:w-full focus:outline-slate-400 col-span-3 w-full"
            onPlaceSelected={place => {
              if (place.formatted_address) {
                setAddress(place.formatted_address);
              }
            }}
            options={{
              componentRestrictions: {
                country: ["us"]
              },
              fields: ["all"],
              types: ["address"]
            }}></AutoComplete>
        </div>
        <Button
          analyticsProperty="email subscribe"
          modifier="primary"
          className="w-auto"
          type="submit"
          loading={loadingRepresentative}
          disabled={fullName.length === 0 || address.length === 0}
          onClick={getNearestRepresentative}>
          Contact your Representative
        </Button>
        {legislator && (
          <CongressEmailContent
            legislator={legislator}
            senderName={fullName}
            senderAddress={address}
          />
        )}
      </section>
    </>
  );
};

export default ContactCongress;
